import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "Depreciation", href: "#depreciation" },
    { label: "Insurance Estimates", href: "#estimates" },
    { label: "Holdback Funds", href: "#holdback" },
    { label: "Cut Corners", href: "#corners" },
    { label: "How We Help", href: "#help" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-[#1a1a2e] shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-20">
        {/* Logo */}
        <a href="#" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.wixstatic.com/media/28e51a_df22dda9c3394c88916d580da8d75922~mv2.png/v1/fill/w_156,h_156,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/RidgecapCircleLogo_white.png"
            alt="RidgeCap GC Logo"
            className="h-14 w-14 object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-white/90 hover:text-[#f97316] text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href="tel:4793964040"
            className="text-white text-sm font-semibold whitespace-nowrap cursor-pointer hover:text-[#f97316] transition-colors"
          >
            <i className="ri-phone-line mr-1"></i> 479-396-4040
          </a>
          <a
            href="#cta"
            className="bg-[#f97316] hover:bg-[#ea6c0a] text-white text-sm font-bold px-5 py-2.5 rounded-md whitespace-nowrap cursor-pointer transition-colors duration-200"
          >
            Free Inspection
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden text-white text-2xl cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#1a1a2e] border-t border-white/10 px-4 pb-6 pt-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="text-white/90 hover:text-[#f97316] text-base font-medium transition-colors cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#cta"
            onClick={() => setMenuOpen(false)}
            className="bg-[#f97316] hover:bg-[#ea6c0a] text-white text-sm font-bold px-5 py-3 rounded-md text-center whitespace-nowrap cursor-pointer transition-colors"
          >
            Free Inspection
          </a>
        </div>
      )}
    </nav>
  );
}
